__webpack_require__.p = "/oxbo-translation-app/";